import type { GqFilterValue, GqlFieldConfig } from "@/admin/FieldConfig.tsx";
import { notNull } from "@warrenio/utils/notNull";
import { createContext, useContext } from "react";

export interface FilterEditorProps {
    value: GqFilterValue;
    setValue: (value: GqFilterValue | null) => void;
    fieldConfig: GqlFieldConfig<any, any, any>;
}

/** Use a context to pass the filter's value etc. to the editors, to avoid prop drilling and make it easy to pass custom props to the filter components. */
export const FilterContext = createContext<FilterEditorProps | null>(null);

export function useFilterContext(): FilterEditorProps {
    return notNull(useContext(FilterContext), "FilterContext");
}
